import { useState, useEffect } from 'react';
import { IonModal, IonButton, IonIcon, IonImg } from '@ionic/react';
import { close } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { CleanHTML } from '../../../defines/Functions';
import axios from "axios";
import Loading from '../../Loading';
import './HotelRoomTerm.css';
import warningSign from '../../../assets/images/warning.svg';

interface Props {
    data: any,
    dataDefines?: any
}
const HotelRoomTerm = (props: Props) => {
    const hotelsRules = Constants.api.hotelsRules;
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showHotelRoomTermModal: false,
        bookingRule: [],
        errorMessage: ''
    });
    useEffect(() => {
        let xmlData = '<OTA_HotelBookingRuleRQ CorrelationID="' + props.data.id + '">';
        xmlData += '<RuleMessage BrandCode="' + props.data.companyName.code + '" BrandName="' + props.data.companyName.companyShortName + '" />';
        xmlData += '</OTA_HotelBookingRuleRQ>';
        const getHotelRoomTerm = async () => {
            setLoading(true);
            try {
                const results = await axios.post(hotelsRules, xmlData, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                });
                if (results.data.status === 'error') {
                    setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس' });
                    setLoading(false);
                } else {
                    if (results.data.items.ruleMessage !== undefined) {
                        if (results.data.items.ruleMessage.bookingRules.bookingRule.length === 0) {
                            setState({ ...state, bookingRule: [], errorMessage: 'نتیجه ای یافت نشد' });
                        } else {
                            setState({ ...state, bookingRule: results.data.items.ruleMessage.bookingRules.bookingRule, errorMessage: '' });
                        }
                    } else {
                        setState({ ...state, bookingRule: [], errorMessage: 'نتیجه ای یافت نشد' });
                    }
                    setLoading(false);
                }
            } catch (error) {
                console.log(error);
                setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس' });
                setLoading(false);
            }
        }
        if (state.showHotelRoomTermModal) {
            getHotelRoomTerm();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotelsRules, state.showHotelRoomTermModal]);
    return (
        <>
            <IonModal isOpen={state.showHotelRoomTermModal} onDidDismiss={() => setState({ ...state, showHotelRoomTermModal: false })} mode="ios" cssClass="hotel-room-term-modal">
                <div className="hotel-room-term-modal-content">
                    <h3 className="hotel-room-term-modal-title">
                        قوانین اتاق
                        <IonIcon icon={close} onClick={() => setState({ ...state, showHotelRoomTermModal: false })} />
                    </h3>
                    <div className="hotel-room-term-modal-items">
                        {!loading ?
                            state.errorMessage.trim().length !== 0 ?
                                <div className="box-error">
                                    <IonImg src={warningSign} />
                                    <p>{state.errorMessage}</p>
                                </div>
                                :
                                state.bookingRule.map((rule: any, index: number) =>
                                    <div key={"index" + index}>
                                        {rule.description.map((desc: any, descIndex: number) =>
                                            <p key={"index" + descIndex} className={props.dataDefines.targetName === 'International' ? 'ion-text-left' : 'ion-text-justify'}>
                                                {CleanHTML(desc.text)}
                                            </p>
                                        )}
                                    </div>
                                )
                            :
                            <Loading />
                        }
                    </div>
                </div>
            </IonModal>
            <IonButton color="primary" expand="block" onClick={() => setState({ ...state, showHotelRoomTermModal: true })}>
                قوانین و مقررات
            </IonButton>
        </>
    );
};
export default HotelRoomTerm;